import { render, staticRenderFns } from "./AreaChartLarge.vue?vue&type=template&id=05a22570&lang=pug"
import script from "./AreaChartLarge.vue?vue&type=script&lang=js"
export * from "./AreaChartLarge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports